import axios from 'axios';
import getHeaders from '../../constants/headers';
import { CONSUMER_BASE_URL } from '../BaseURL';

export const getStoreCustomerAccountTransaction = (storeCustomerId, storeId) => {
  return axios({
    method: 'get',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/store-customer-account-transaction', // for android use
    headers: getHeaders(),
  });
};
